import React, { useEffect, useState } from 'react';
import { useConsultation } from '../../../ReduxSlices/Consultations/consultationProvider';
import PropTypes from 'prop-types';
import ConsultationEditor from './editConsultations';
import ConsultationList from './consultationList';
import LoadingDots from '../../shared/LoadingDots';

const ConsultationSection = ({ patientId, currentUserId }) => {
  const { consultations, setConsultations, loading } = useConsultation();
  const [notes, setNotes] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [editingId, setEditingId] = useState(null);

  const handleSubmit = async () => {
    if (!notes.trim()) return;

    setSubmitting(true);
    const payload = {
      consultation: {
        patient_id: patientId,
        notes,
      },
    };

    const method = editingId ? 'PATCH' : 'POST';
    const url = editingId
      ? `/api/v1/consultations/${editingId}`
      : '/api/v1/consultations';

    try {
      const res = await fetch(url, {
        method,
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });

      const updated = await res.json();
      if (editingId) {
        setConsultations((prev) => prev.map((c) => (c.id === updated.id ? updated : c)));
      } else {
        setConsultations((prev) => [updated, ...prev]);
      }

      setNotes('');
      setEditingId(null);
    } catch (err) {
      console.error(err);
    } finally {
      setSubmitting(false);
    }
  };

  const handleEdit = (consultation) => {
    setEditingId(consultation.id);
    setNotes(consultation.notes);
  };

  const handleCancel = () => {
    setEditingId(null);
    setNotes('');
  };

  return (
    <div className="space-y-4">
      <ConsultationEditor
        notes={notes}
        setNotes={setNotes}
        onSubmit={handleSubmit}
        submitting={submitting}
        onCancel={handleCancel}
        isEditing={!!editingId}
      />

      <hr />

      <div>
        <h3 className="text-lg font-semibold">Previous Consultations</h3>
        {loading ? (
          <LoadingDots height={10} width={30} color="#38AD3E" />

        ) : (
          <ConsultationList
            consultations={consultations}
            currentUserId={currentUserId}
            onEdit={handleEdit}
          />
        )}
      </div>
    </div>
  );
};

ConsultationSection.propTypes = {
  patientId: PropTypes.number.isRequired,
  currentUserId: PropTypes.number.isRequired,
};

export default ConsultationSection;